import React from "react";

const EncabezadoAlumno = ({ alumno, vistaActiva, onVolver }) => {
  return (
    <div className="Dashboard-card info-alumno-card" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <h3 style={{ margin: '0 0 5px 0', color: '#003b5c' }}>
          {vistaActiva === 'cobro' && 'Cobrando a: '}
          {vistaActiva === 'registrar_pago' && 'Registrando Pago de: '}
          {vistaActiva === 'historial' && 'Historial de: '}
          {alumno.nombres} {alumno.apellido_paterno} {alumno.apellido_materno}
        </h3>
        <p style={{ margin: 0, color: '#666' }}>
          <strong>Matrícula:</strong> {alumno.matricula} | 
          <strong> Plantel:</strong> {alumno.nombre_plantel ? alumno.nombre_plantel.replace('CECYTEJ', '').trim() : ''} | 
          <strong> Grado:</strong> {alumno.grado} | 
          <strong> Grupo:</strong> {alumno.grupo}
        </p>
      </div>
      <button className="btn-logout" onClick={onVolver}>
        ← Volver a Búsqueda
      </button>
    </div>
  );
};

export default EncabezadoAlumno;